export type PreviewDevice = "desktop" | "tablet" | "mobile"

export type AppContext = Record<string, any>
